/**
* Adds a Confused.ServiceProxy class to the Confused namespace. 
* Implemented as IIFE so we can pass in references to the global jQuery and document objects.
**/
(function($, w) {

    'use strict';

    w.Confused = w.Confused || {};

    /**
    * ServiceProxy abstracts away some of the horrors of dealing with asp.net PageMethods
    *
    * @param {string} endpoint the endpoint to hit
    * @constructor
    **/
    w.Confused.ServiceProxy = function(endpoint, timeout) {

        this.endpoint = endpoint;

        this.timeout = timeout || 300;
    };


    /**
    * invoke the service proxy using the given options
    *
    * @param {object} options the options
    * @param {string} options.method the method to invoke
    * @param {object | string} options.data data to act as parameter for the remote method
    * @param {function} options.success callback for successful invocation
    * @param {function} [options.error] callback for error on invocation
    * @function
    */
    w.Confused.ServiceProxy.prototype.invoke = function(options) {

        var url, data;

        if (!options.method) {

            if (this.endpoint) {
                throw new Error('method not specified for service: ' + this.endpoint);
            } else {
                throw new Error('Error invoking service');
            }
        }

        url = '/' + this.endpoint + '/' + options.method;

        data = typeof options.data === 'object' ? JSON.stringify(options.data) : options.data;

        return $.ajax({

            type: 'POST',
            url: url,
            data: data,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',

            //handles stupid MS JSON format!!
            converters: {
                'text json': function(result) {
                    var msg = (window.JSON && window.JSON.parse) ? JSON.parse(result) : $.parseJSON(result);
                    return msg.hasOwnProperty('d') ? msg.d : msg;
                }
            }
        });
    };

}(window.jQuery, window));